import { Mui } from "@osu/react-ui";

const listReset = {
  [`& li:first-of-type`]: {
    paddingTop: 0,
  },
  [`& li:last-of-type`]: {
    paddingBottom: 0,
    marginBottom: `1rem`,
  },
};

const hoverPalette = (theme) => {
  const darkGrays = theme.palette.brand.gray.darker;
  const lightGrays = theme.palette.brand.gray.lighter;
  const isDarkMode = theme.palette.mode === "dark";

  return {
    backgroundColor: (isDarkMode ? darkGrays : lightGrays)[80],
    borderColor: (isDarkMode ? lightGrays : darkGrays)[40],
  }
}

const navLinkStyles = ({ isSame, disableHighlightCurrent }) => [
  (theme) => {
    const { backgroundColor, borderColor } = hoverPalette(theme)
    let cls = {
      textTransform: "none",
      borderBottom: `4px solid transparent`,
      height: '100%',
      borderRadius: 0,
      padding: `.25rem 0`,
      alignSelf: "bottom",
      color: theme.palette.textColor,
      [`&.${Mui.buttonClasses.textPrimary}`]: {
        color: theme.palette.textColor,
      },
      "&:hover": {
        backgroundColor,
        borderBottomColor: borderColor,
      },
    };
    if(isSame && !disableHighlightCurrent) {
        cls.borderBottomColor = theme.palette.brand.gray.main
    }
    return cls
  }
]

const navLinkDropdownStyles = (theme) => {
  const { backgroundColor, borderColor } = hoverPalette(theme)

  return {
    borderLeft: `4px solid transparent`,
    "&:hover": {
      backgroundColor,
      borderLeftColor: borderColor,
    }

  }
}

export {
    listReset,
    navLinkStyles,
    navLinkDropdownStyles
}